import { render } from "./PropertiesForRentChart.vue?vue&type=template&id=5d2ba022&ts=true"
import script from "./PropertiesForRentChart.vue?vue&type=script&lang=ts"
export * from "./PropertiesForRentChart.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__